export default class AddonRepository {
  constructor(addOnApiService) {
    if (new.target === AddonRepository) throw new Error("Cannt instantiage an abstract class.");

    if (this.getAddonById === AddonRepository.prototype.getAddonById) throw new Error("Class extending AddonRepository must override 'getAddonById'");

    this.addOnApiService = addOnApiService;
  }

  async getActiveAddons() {
    throw new Error("Method 'getActiveAddons()' must be implemented.");
  }

  async getAddons() {
    throw new Error("Method 'getAddons()' must be implemented.");
  }

  async availAddon(data) {
    throw new Error("Method 'availAddon(addOnId)' must be implemented.");
  }

  async getAddonById(addOnId) {
    throw new Error("Method 'getAddonById(addOnId)' must be implemented.");
  }
}
